<span
  class="badge"
  [class.red]="tone === 'red'"
  [class.amber]="tone === 'amber'"
  [class.clear]="tone === 'clear'"
  >{{ label }}</span
>
